module.exports = __webpack_public_path__ + "06_short_brown.582ad8a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/06_short_brown.png
// module id = ULM1
// module chunks = 0